const bundleVariantFirst = document.querySelector('.bundle-swatch-first');
bundleVariantFirst.addEventListener('change', (event) => {
   
    if(event.target.getAttribute('name') == 'Color_first') {
      let childElements = bundleVariantFirst.querySelectorAll('.active');
      childElements.forEach(childElement => {
          childElement.classList.remove('active'); 
      });
      event.target.nextElementSibling.classList.add('active');
    }

    const fieldsetFirst = Array.from(bundleVariantFirst.querySelectorAll('fieldset'));
    const optionsFirst = fieldsetFirst.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    })
    
    let variantDataFirst = JSON.parse(document.querySelector('[bundle="application/bundle_swatch_first"]').textContent);
    let currentVariantFirst = variantDataFirst.find((variant) => {
      return !variant.options.map((option, index) => {
        return optionsFirst[index] === option;
      }).includes(false);
    });

    if (!currentVariantFirst) return;
  
    const inputFirst = document.querySelector('input[name="bundle_first"]');
    inputFirst.value = currentVariantFirst.id;

    let bundleFirstElem = document.querySelector('.disabled-'+currentVariantFirst.id);

    let bundleSecond = document.querySelector('input[name="bundle_second"]');
    let bundleSecondElem = document.querySelector('.disabled-'+bundleSecond.value);

    let bundleThird = document.querySelector('input[name="bundle_third"]');
    if(bundleThird) {
      var bundleThirdElem = document.querySelector('.disabled-'+bundleThird.value);
    }
  
	if(bundleFirstElem.getAttribute('data-inventory') == 'pre-order' || bundleSecondElem.getAttribute('data-inventory') == 'pre-order') {
	  let bundleAddToCart = document.getElementById('bundle_add_text');
	  bundleAddToCart.innerText = 'Pre-Order Now';
      document.getElementById("vitals-preorder-note").style.display = 'block';
    } else if(bundleThird) {
      if(bundleThirdElem.getAttribute('data-inventory') == 'pre-order') {
        let bundleAddToCart = document.getElementById('bundle_add_text');
    	bundleAddToCart.innerText = 'Pre-Order Now';
        document.getElementById("vitals-preorder-note").style.display = 'block';
      } else {
        let bundleAddToCart = document.getElementById('bundle_add_text');
	    bundleAddToCart.innerText = 'Add to bag';
        document.getElementById("vitals-preorder-note").style.display = 'none';
      }
    } else {
      let bundleAddToCart = document.getElementById('bundle_add_text');
	  bundleAddToCart.innerText = 'Add to bag';
      document.getElementById("vitals-preorder-note").style.display = 'none';
    }
    
    inputFirst.dispatchEvent(new Event('change', { bubbles: true }));
    const colorNameFirst = document.querySelector('.color_name_first');
    if (colorNameFirst !== null) {
      colorNameFirst.innerHTML = currentVariantFirst.option1; 
    }
})

const bundleVariantSecond = document.querySelector('.bundle-swatch-second');
bundleVariantSecond.addEventListener('change', (event) => {

    if(event.target.getAttribute('name') == 'Color_second') {
      let childElements = bundleVariantSecond.querySelectorAll('.active');
      childElements.forEach(childElement => {
          childElement.classList.remove('active'); 
      });
      event.target.nextElementSibling.classList.add('active');
    }
  
    const fieldsetSecond = Array.from(bundleVariantSecond.querySelectorAll('fieldset'));
    const optionsSecond = fieldsetSecond.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    })
    
    let variantDataSecond = JSON.parse(document.querySelector('[bundle="application/bundle_swatch_second"]').textContent);
    
    let currentVariantSecond = variantDataSecond.find((variant) => {
      return !variant.options.map((option, index) => {
        return optionsSecond[index] === option;
      }).includes(false);
    });

    if (!currentVariantSecond) return;
  
    const inputSecond = document.querySelector('input[name="bundle_second"]');
    inputSecond.value = currentVariantSecond.id;
    
    let bundleFirst = document.querySelector('[name="bundle_first"]');
    let bundleFirstElem = document.querySelector('.disabled-'+bundleFirst.value);

    let bundleThird = document.querySelector('[name="bundle_third"]');
    if(bundleThird) {
      var bundleThirdElem = document.querySelector('.disabled-'+bundleThird.value); 
    }
    let bundleSecondElem = document.querySelector('.disabled-'+currentVariantSecond.id);
  
	if(bundleFirstElem.getAttribute('data-inventory') == 'pre-order' || bundleSecondElem.getAttribute('data-inventory') == 'pre-order') {
	  let bundleAddToCart = document.getElementById('bundle_add_text');
	  bundleAddToCart.innerText = 'Pre-Order Now';
      document.getElementById("vitals-preorder-note").style.display = 'block';
    } else if(bundleThird) {
      if(bundleThirdElem.getAttribute('data-inventory') == 'pre-order') {
        let bundleAddToCart = document.getElementById('bundle_add_text');
    	bundleAddToCart.innerText = 'Pre-Order Now';
        document.getElementById("vitals-preorder-note").style.display = 'block';
      } else {
        let bundleAddToCart = document.getElementById('bundle_add_text');
	    bundleAddToCart.innerText = 'Add to bag';
        document.getElementById("vitals-preorder-note").style.display = 'none';
      }
    } else {
      let bundleAddToCart = document.getElementById('bundle_add_text');
	  bundleAddToCart.innerText = 'Add to bag';
      document.getElementById("vitals-preorder-note").style.display = 'none';
    }
  
    inputSecond.dispatchEvent(new Event('change', { bubbles: true }));
    const colorNameSecond = document.querySelector('.color_name_second');
    if (colorNameSecond !== null) {
      colorNameSecond.innerHTML = currentVariantSecond.option1;
    }
})

const bundleVariantThird = document.querySelector('.bundle-swatch-third');
console.log('bundleVariantThird', bundleVariantThird)
if(bundleVariantThird) {
  bundleVariantThird.addEventListener('change', (event) => {
  
      if(event.target.getAttribute('name') == 'Color_third') {
        let childElements = bundleVariantThird.querySelectorAll('.active');
        childElements.forEach(childElement => {
            childElement.classList.remove('active'); 
        });
        event.target.nextElementSibling.classList.add('active');
      }
    
      const fieldsetThird = Array.from(bundleVariantThird.querySelectorAll('fieldset'));
      const optionsThird = fieldsetThird.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      })
      
      let variantDataThird = JSON.parse(document.querySelector('[bundle="application/bundle_swatch_third"]').textContent);
      
      let currentVariantThird = variantDataThird.find((variant) => {
        return !variant.options.map((option, index) => {
          return optionsThird[index] === option;
        }).includes(false);
      });
  
      if (!currentVariantThird) return;
    
      const inputThird = document.querySelector('input[name="bundle_third"]');
      inputThird.value = currentVariantThird.id;
      
      let bundleFirst = document.querySelector('[name="bundle_first"]');
      let bundleFirstElem = document.querySelector('.disabled-'+bundleFirst.value);
  
      let bundleSecond = document.querySelector('input[name="bundle_second"]');
      let bundleSecondElem = document.querySelector('.disabled-'+bundleSecond.value);
  
      let bundleThirdElem = document.querySelector('.disabled-'+currentVariantThird.id);
    
  	if(bundleFirstElem.getAttribute('data-inventory') == 'pre-order' || bundleSecondElem.getAttribute('data-inventory') == 'pre-order' || bundleThirdElem.getAttribute('data-inventory') == 'pre-order') {
  	  let bundleAddToCart = document.getElementById('bundle_add_text');
  	  bundleAddToCart.innerText = 'Pre-Order Now';
        document.getElementById("vitals-preorder-note").style.display = 'block';
      } else {
        let bundleAddToCart = document.getElementById('bundle_add_text');
  	    bundleAddToCart.innerText = 'Add to bag';
        document.getElementById("vitals-preorder-note").style.display = 'none';
      }
    
      inputThird.dispatchEvent(new Event('change', { bubbles: true }));
      const colorNameThird = document.querySelector('.color_name_second');
      if (colorNameThird !== null) {
        colorNameThird.innerHTML = currentVariantThird.option1;
      }
  })
}

const bundleAddToCart = document.getElementById('bundle_add')
bundleAddToCart.addEventListener('click', (event) => {

    let checkFirst  = document.querySelectorAll('input[type="radio"][name="Size_first"]');
    let checkSecond = document.querySelectorAll('input[type="radio"][name="Size_second"]');
    let checkThird = document.querySelectorAll('input[type="radio"][name="Size_third"]');
 
    let anyFirstSelected = false;
    checkFirst.forEach(radioInput => {
        if (radioInput.checked) {
            anyFirstSelected = true;
        }
    });

    let anySecondSelected = false;
    checkSecond.forEach(radioInput => {
        if (radioInput.checked) {
            anySecondSelected = true;
        }
    });
    if (!anyFirstSelected || !anySecondSelected) {
        ksHandleErrorMessage("Please choose a size.");
        document.getElementById('bundle_add').classList.remove('disabled');
        return;
    } else if(checkThird.length > 0) {
      let anyThirdSelected = false;
      checkThird.forEach(radioInput => {
          if (radioInput.checked) {
              anyThirdSelected = true;
          }
      });
      if(!anyThirdSelected) {
        ksHandleErrorMessage("Please choose a size.");
        document.getElementById('bundle_add').classList.remove('disabled');
        return;
      }
    }
    document.querySelector('.product-form__error-message-wrapper').setAttribute("hidden", true);
  
    document.getElementById('bundle_add').classList.add('disabled');
    const bundleParentID = document.querySelector('input[name="_bundle_parent_id"]');
    const bundleTitle = document.querySelector('input[name="_bundle_title"]');
    const bundleURL = document.querySelector('input[name="_bundle_url"]');
    const bundlePrice = document.querySelector('input[name="_bundle_price"]');
    const getInputFirst = document.querySelector('input[name="bundle_first"]');
    const getInputSecond = document.querySelector('input[name="bundle_second"]');
    const getInputThird = document.querySelector('input[name="bundle_third"]');
    const isCategory = document.querySelector('.propertyCatagory');
    //check outofstock
    var forceCheckFirst = $('.disabled-bundle-swatch-first .disabled-'+getInputFirst.value);
    var forceCheckSecond = $('.disabled-bundle-swatch-second .disabled-'+getInputSecond.value);
    if(getInputThird) {
      var forceCheckThird = $('.disabled-bundle-swatch-third .disabled-'+getInputThird.value);
    }
    if(forceCheckFirst.text() == 'disabled') {
      ksHandleErrorMessage("The product '"+forceCheckFirst.attr('data-name')+"' is already sold out.");
      document.getElementById('bundle_add').classList.remove('disabled');
      return;
    } else if(forceCheckSecond.text() == 'disabled') {
      ksHandleErrorMessage("The product '"+forceCheckSecond.attr('data-name')+"' is already sold out.");
      document.getElementById('bundle_add').classList.remove('disabled');
      return;
    } else if(getInputThird && forceCheckThird.text() == 'disabled') {
        ksHandleErrorMessage("The product '"+forceCheckThird.attr('data-name')+"' is already sold out.");
        document.getElementById('bundle_add').classList.remove('disabled');
        return;
    } else {
     
      let bundleID = uniqueRandomBundleID();
      let formData = {
        'items': [{
          'id': getInputFirst.value,
          'quantity': 1,
          'properties': {
            '_bundle_parent_id': bundleParentID.value,
            '_bundle_title': bundleTitle.value,
            '_bundle_url': bundleURL.value,
            '_bundle_id': bundleID,
            '_bundle_price': bundlePrice.value,
            'Note': (forceCheckFirst.attr('data-inventory') == 'pre-order') ? 'Pre-order' : '',
            '_ordering': 'First',
             ...(isCategory && isCategory.value ? { Category: isCategory.value } : {})
          }},
          {
          'id': getInputSecond.value,
          'quantity': 1,
          'properties': {
            '_bundle_parent_id': bundleParentID.value,
            '_bundle_title': bundleTitle.value,
            '_bundle_url': bundleURL.value,
            '_bundle_id': bundleID,
            '_bundle_price': bundlePrice.value,
            'Note': (forceCheckSecond.attr('data-inventory') == 'pre-order') ? 'Pre-order' : '',
            '_ordering': 'Second',
             ...(isCategory && isCategory.value ? { Category: isCategory.value } : {})
          }}
        ]
      };

      if(getInputThird) {
        console.log('New object to concatenate');
        let newObjectToConcat = {
          'id': getInputThird.value,
          'quantity': 1,
          'properties': {
            '_bundle_parent_id': bundleParentID.value,
            '_bundle_title': bundleTitle.value,
            '_bundle_url': bundleURL.value,
            '_bundle_id': bundleID,
            '_bundle_price': bundlePrice.value,
            'Note': (forceCheckThird.attr('data-inventory') == 'pre-order') ? 'Pre-order' : '',
            '_ordering': 'Third',
             ...(isCategory && isCategory.value ? { Category: isCategory.value } : {})
          }};
        formData.items.push(newObjectToConcat);
        
      }

     
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then((response) => response.json())    
      .then((response) => {
       
        const cart = document.querySelector('bundle-cart-notification');
        
        if (response.status) {
          document.getElementById('bundle_add').classList.remove('disabled');
          return;
        } else if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }
  
        var html = '';
        var ids = [];
        response.items.map((item => {
         ids.push("'"+item.key+"'");
          var note = '';
         if(item.properties.Note !== '') {
          note += '<div class="product-option"><dt>Note: </dt><dd>'+item.properties.Note+'</dd></div>';
         } 
          if(item.properties.Category !== '') {
          note += '<div class="product-option"><dt>Category: </dt><dd>'+item.properties.Category+'</dd></div>';
         }
         html += '<div class="bundle-popup-items"><img class="cart-notification-product__image" src="'+item.featured_image.url+'" alt="'+item.product_title+'" loading="lazy" width="70" height="93"><div><h3 class="cart-notification-product__name h4">'+item.product_title+'</h3><dl><div class="product-option"><dt>'+item.options_with_values[0].name+': </dt><dd>'+item.options_with_values[0].value+'</dd></div><div class="product-option"><dt>'+item.options_with_values[1].name+': </dt><dd>'+item.options_with_values[1].value+'</dd></div>'+note+'</dl></div></div>'; 
        }));
  
        html +='<cart-remove-button><a onclick="remove_bundles(this, '+ids+')" class="button button--tertiary remove-bundle" id="remove_bundle" data-ids="'+ids+'">Remove</a></cart-remove-button>';
        document.getElementById('bundle-cart-notification-product').innerHTML = html;
        var activeNotify = document.getElementById('bundle-cart-notification-focus');
        activeNotify.classList.add('animate', 'active');
        
        fetch(window.Shopify.routes.root + 'cart.js', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(response => {
          return response.json();
        })
        .then((response) => {
          document.getElementById('bundle-cart-notification-button').innerHTML = 'View my cart ('+response.item_count+')';
          if($('#cart-icon-bubble').find('span').length == 1) {
           $('#cart-icon-bubble').append('<div class="cart-count-bubble"><span aria-hidden="true">'+response.item_count+'</span><span class="visually-hidden">'+response.item_count+' items</span></div>');
          } else {
            $('#cart-icon-bubble .cart-count-bubble').html('<span aria-hidden="true">'+response.item_count+'</span><span class="visually-hidden">'+response.item_count+' items</span>');
          }
        });
      
       document.getElementById('bundle_add').classList.remove('disabled');
        
      })
      .catch((e) => {
        document.getElementById('bundle_add').classList.remove('disabled');
      });
    }
})
const bundleNotifyClose = document.getElementById('bundle-cart-notification__close')
bundleNotifyClose.addEventListener('click', (event) => {
  document.getElementById('bundle-cart-notification-focus').classList.remove('animate', 'active');
})


function ksHandleErrorMessage(errorMessage = false) {
  let errorMessageWrapper = document.querySelector('.product-form__error-message-wrapper');
  if (!errorMessageWrapper) return;
   
  let errorFormMessage = errorMessageWrapper.querySelector('.product-form__error-message');
  errorMessageWrapper.toggleAttribute('hidden', !errorFormMessage);
  
  if (errorMessage) {
    //errorFormMessage.textContent = errorMessage;
  }
}
  
function remove_bundles(event, one, two = '', three = ''){
  var qty = 0;
  var data = { updates: {} };
  data.updates[one] = qty;
  if(two) {
     data.updates[two] = qty;
  }
  if(three) {
     data.updates[three] = qty;
  }

  var data = {
    'id': one,
    'quantity': 0
  }
  
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({'id': one, 'quantity': 0 })
  }).then(response => response.json()).then(data => { 
    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({'id': two, 'quantity': 0})
    }).then(response => response.json()).then(data => {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({'id': three, 'quantity': 0})
      }).then(response => response.json()).then(data => {
       window.location.reload();
      }).catch((error) => {
          console.error('Error:', error);
      });
    }).catch((error) => {
        console.error('Error:', error);
    });

  }).catch((error) => {
      console.error('Error:', error);
  });
}

function uniqueRandomBundleID() {
  return "xxxxxxxx-xxxx-7xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (k) {
  	var j = (16 * Math.random()) | 0;
  	return ("x" == k ? j : (3 & j) | 8).toString(16);
  });
}

document.addEventListener("DOMContentLoaded", function() {

  //  This is for to change the pre-order to add-to-bag, Means bydefault if product has out-of-stock then we are set the another variant in-stock as active 
  var getSetBundleFirstID = '';
  document.querySelectorAll('.disabled-bundle-swatch-first').forEach(function(mainElement) {
    mainElement.querySelectorAll('p').forEach(function(paragraph) {
      let inventoryText = paragraph.getAttribute('data-inventory');
      if(inventoryText == '' && getSetBundleFirstID == '') {
        getSetBundleFirstID = paragraph.getAttribute('data-id');
        return;
      }
    });
  });
  
  if(getSetBundleFirstID !== '') {
    let bundleFirst = document.querySelector('input[name="bundle_first"]');
    bundleFirst.value = getSetBundleFirstID;
  }

  var getSetBundleSecondID = '';
  document.querySelectorAll('.disabled-bundle-swatch-second').forEach(function(mainElement) {
    mainElement.querySelectorAll('p').forEach(function(paragraph) {
      let inventoryText = paragraph.getAttribute('data-inventory');
      if(inventoryText == '' && getSetBundleSecondID == '') {
        getSetBundleSecondID = paragraph.getAttribute('data-id');
        return;
      }
    });
  });

  if(getSetBundleSecondID !== '') {
    let bundleSecond = document.querySelector('input[name="bundle_second"]');
    bundleSecond.value = getSetBundleSecondID;
  }

  var getSetBundleThirdID = '';
  document.querySelectorAll('.disabled-bundle-swatch-third').forEach(function(mainElement) {
    mainElement.querySelectorAll('p').forEach(function(paragraph) {
      let inventoryText = paragraph.getAttribute('data-inventory');
      if(inventoryText == '' && getSetBundleThirdID == '') {
        getSetBundleThirdID = paragraph.getAttribute('data-id');
        return;
      }
    });
  });

  if(getSetBundleThirdID !== '') {
    let bundleThird = document.querySelector('input[name="bundle_third"]');
    bundleThird.value = getSetBundleThirdID;
  }
  
  let bundleFirst = document.querySelector('input[name="bundle_first"]');
  let bundleSecond = document.querySelector('input[name="bundle_second"]');
  let bundleThird = document.querySelector('input[name="bundle_third"]');
  
  let bundleFirstElem = document.querySelector('.disabled-'+bundleFirst.value);
  let bundleSecondElem = document.querySelector('.disabled-'+bundleSecond.value);
  if(bundleThird){
    var bundleThirdElem = document.querySelector('.disabled-'+bundleThird.value);
  }
  
  if(bundleFirstElem.getAttribute('data-inventory') == 'pre-order' || bundleSecondElem.getAttribute('data-inventory') == 'pre-order') {
    let bundleAddToCart = document.getElementById('bundle_add_text');
    bundleAddToCart.innerText = 'Pre-Order Now';
    document.getElementById("vitals-preorder-note").style.display = 'block'; 
  } else if(bundleThird) {
    if(bundleThirdElem.getAttribute('data-inventory') == 'pre-order') {
      let bundleAddToCart = document.getElementById('bundle_add_text');
      bundleAddToCart.innerText = 'Pre-Order Now';
      document.getElementById("vitals-preorder-note").style.display = 'block'; 
    }
  }

});
